import { Component, OnInit, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LinkService } from '../../_services/langhfre.service';
import { LoadScriptService } from 'src/app/_services/load-script.service';
import { NavigationService } from 'src/app/_services/navigation.service';
import { WebsiteService } from 'src/app/_services/website.service';
import { RecaptchaService } from 'src/app/_services/recaptcha.service';

@Component({
  selector: 'app-enterprise',
  templateUrl: './enterprise.component.html',
  styleUrls: ['./enterprise.component.scss']
})
export class EnterpriseComponent implements OnInit {

  heroForm: FormGroup;
  heroFormSection: boolean = true;
  heroThankSection: boolean = false;
  isSubmitting: boolean = false;
  activeFaqIndex: number = -1;

  tabs = ['Clinical', 'Technical', 'Legal', 'Formal'];

  activeTab = 0;

  setTab(index: number) {
    this.activeTab = index;
  }
  
  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    public loadScript: LoadScriptService,
    public navigationService: NavigationService,
    private fb: FormBuilder,
    private networkCall: WebsiteService,
    private toastr: ToastrService,
    private recaptcha: RecaptchaService,
    private router: Router
  ) {
    this.heroForm = this.fb.group({
      name: ['', Validators.required],
      designation: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)]],
      phone: ['', Validators.required],
      website: ['']
    });
  }

  ngOnInit() {
    this.titleService.setTitle('Trinka Enterprise - Proofreading Solutions For Your Teams');
    this.metaTagService.updateTag({ name: 'description', content: "Proofreading and AI writing assistance built for businesses. Improve quality, enforce consistency, and keeping confidential documents private." });
    this.metaTagService.updateTag({ property: 'og:title', content: "Trinka Enterprise - Proofreading Solutions For Your Teams" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Proofreading and AI writing assistance built for businesses. Improve quality, enforce consistency, and keeping confidential documents private." });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/enterprise' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/enterprise' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Trinka Enterprise - Proofreading Solutions For Your Teams' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Proofreading and AI writing assistance built for businesses. Improve quality, enforce consistency, and keeping confidential documents private." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/enterprise' });

    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `{"@context":"https://schema.org/","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Trinka AI","item":"https://www.trinka.ai/"},{"@type":"ListItem","position":2,"name":"Trinka Enterprise","item":"https://www.trinka.ai/enterprise"}]}`;
    this._renderer2.appendChild(this._document.head, script);
  }

  toggleFaq(index: number) {
    this.activeFaqIndex = this.activeFaqIndex === index ? -1 : index;
  }

  submitHeroForm() {
    if (this.heroForm.value.website) return;
    if (this.heroForm.invalid) {
      this.heroForm.markAllAsTouched();
      return;
    }
    this.isSubmitting = true;
    this.recaptcha.getToken('enterprise_hero').then(token => {
      const { name, designation, email, phone } = this.heroForm.value;
      const source = this.router.url;
      const query = `Enterprise Hero Form||${name}||${designation}||${phone}||N/A||N/A`;
      this.networkCall.postContactUs(email, query, source).subscribe({
        next: () => {
          this.heroFormSection = false;
          this.heroThankSection = true;
          this.heroForm.reset();
        },
        error: () => {
          this.toastr.warning('Something went wrong!');
        }
      }).add(() => { this.isSubmitting = false; });
    }).catch(() => { this.isSubmitting = false; });
  }

  customLogos = [
    { src: "/assets/images/client_logos/j-j.png", "altText": "johnsons" },
    { src: "/assets/images/client_logos/cigna.png", "altText": "cigna" },
    { src: "/assets/images/client_logos/novartis.png", "altText": "novartis" },
    { src: "/assets/images/client_logos/murata.webp", "altText": "murata" },
    { src: "/assets/images/client_logos/merck.png", "altText": "merck" },
    { src: "/assets/images/client_logos/abbvie.png", "altText": "abbvie" },
    { src: "/assets/images/client_logos/nissin.webp", "altText": "nissin" },
    { src: "/assets/images/client_logos/amgen.png", "altText": "amgen" },
    { src: "/assets/images/client_logos/biogen.png", "altText": "biogen" },
    { src: "/assets/images/client_logos/who.png", "altText": "who" },
    { src: "/assets/images/client_logos/ibs.webp", "altText": "ibs" },
    { src: "/assets/images/client_logos/accelera.png", "altText": "accelera" },
    { src: "/assets/images/client_logos/pfizer.png", "altText": "pfizer" },
    { src: "/assets/images/client_logos/tata-fintech.webp", "altText": "tata fintech" },
  ];
}
